module.exports = __webpack_public_path__ + "img/bl.db226c04.png";